"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const inventory_stock_entity_1 = require("./inventory-stock.entity");
let InventoryService = class InventoryService {
    constructor(stockRepo) {
        this.stockRepo = stockRepo;
    }
    async upsertStock(productId, location, quantityOnHand, reorderLevel = 10) {
        let stock = await this.stockRepo.findOne({
            where: { product: { id: productId }, location },
        });
        if (stock) {
            stock.quantityOnHand = quantityOnHand;
            stock.reorderLevel = reorderLevel;
        }
        else {
            stock = this.stockRepo.create({
                product: { id: productId },
                location,
                quantityOnHand,
                quantityReserved: 0,
                reorderLevel,
            });
        }
        return this.stockRepo.save(stock);
    }
    getStock(productId) {
        if (productId) {
            return this.stockRepo.find({
                where: { product: { id: productId } },
                relations: ['product'],
                order: { location: 'ASC' },
            });
        }
        return this.stockRepo.find({
            relations: ['product'],
            order: { location: 'ASC' },
        });
    }
    async adjustStock(id, quantityDelta, reason) {
        const stock = await this.stockRepo.findOne({
            where: { id },
            relations: ['product'],
        });
        if (!stock)
            throw new common_1.NotFoundException(`InventoryStock #${id} not found`);
        stock.quantityOnHand = stock.quantityOnHand + quantityDelta;
        if (stock.quantityOnHand < 0)
            stock.quantityOnHand = 0;
        // Log the adjustment (reason stored implicitly via audit trail or notes)
        // In a full implementation this would write to an audit log table.
        // Here we persist the updated quantity and return the record.
        const saved = await this.stockRepo.save(stock);
        return saved;
    }
    getStockByProduct(productId) {
        return this.stockRepo.find({
            where: { product: { id: productId } },
            relations: ['product'],
            order: { location: 'ASC' },
        });
    }
    getLowStockAlerts() {
        return this.stockRepo
            .createQueryBuilder('stock')
            .leftJoinAndSelect('stock.product', 'product')
            .where('stock.quantityOnHand <= stock.reorderLevel')
            .orderBy('stock.quantityOnHand', 'ASC')
            .getMany();
    }
};
exports.InventoryService = InventoryService;
exports.InventoryService = InventoryService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(inventory_stock_entity_1.InventoryStock)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object])
], InventoryService);
